/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import { Button, Tooltip, ButtonGroup, Box } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import MDTypography from "components/MDTypography";
import GrupoBotonesEstatusArchivos from "./buttonGroupArchivos";
import { ActualizarEstadoDocumento } from 'store/solicitudes/solicitudesActions'
import { useDispatch } from "react-redux";
import ModalConfirmacion from "./confirmacion";
import { useState } from "react";

function InputFileDownloadClinica({ onClick, estatus, CambiarStatusDocumento, EliminarDocumento, ocultarValidacionarchivo = false, ocultarEliminacion=false }) {
  const dispatch = useDispatch();
     const [valorestatus, setvalorestatus] = useState();
     const [open, setOpen] = useState(false);
     const handleConfirm = async () => {
       setOpen(false);
       CambiarStatusDocumento(valorestatus);
     };
  return (
    <Box display="flex" alignItems="center" gap={1}>
      {/* Botón con texto + ícono realmente grande */}
      <Button
        variant="contained"
        startIcon={<DownloadIcon />}
        color="primary"
        sx={{
          backgroundColor: "#605CA9",
          textTransform: "none"
        }}
        onClick={onClick}
      >
        Descargar
      </Button>

      {/* Botón solo con ícono grande MuiSvgIcon-fontSizeInherit css-kh2smp-MuiSvgIcon-root */}
      {ocultarEliminacion ? null : <Tooltip title="Eliminar archivo">
        <Button
          variant="contained"
          sx={{
            padding:0,
            backgroundColor: "#d32f2f",
            "&:hover": { backgroundColor: "#b71c1c" },
            "& .MuiSvgIcon-root":{fontSize:"1.5rem !important",}
          }}
          onClick={EliminarDocumento}
        >
          <DeleteIcon sx={{ color: "#fff" }} />
        </Button>
      </Tooltip>}
      {ocultarValidacionarchivo ? null :
      <GrupoBotonesEstatusArchivos 
        estatus={estatus}
        onSeleccion={(opcion)=>{
          setOpen(true);
          setvalorestatus(opcion);
        }}
        validadoPor={""}
      />}
      
        <ModalConfirmacion
          open={open}
          onClose={() => setOpen(false)}
          onConfirm={handleConfirm}
          titulo="Comfirmación"
          mensaje="¿Estás seguro que deseas cambiar el estatus?"
        />

    </Box>
  );
}



export default InputFileDownloadClinica;